import Project from "./patterns/ProjectHero";
import Journal from "./patterns/JournalHero";
import Issue from "./patterns/IssueHero";

export default {
  Project,
  Journal,
  Issue
};
